export const PlusIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 2.99707C7 2.44479 7.44772 1.99707 8 1.99707C8.55228 1.99707 9 2.44479 9 2.99707V12.9971C9 13.5494 8.55228 13.9971 8 13.9971C7.44772 13.9971 7 13.5494 7 12.9971V2.99707Z"
      fill="currentColor"
    />
    <path
      d="M13 6.99707C13.5523 6.99707 14 7.44479 14 7.99707C14 8.54936 13.5523 8.99707 13 8.99707L3 8.99707C2.44771 8.99707 2 8.54936 2 7.99707C2 7.44479 2.44772 6.99707 3 6.99707L13 6.99707Z"
      fill="currentColor"
    />
  </svg>
);
